import React from "react";
import { Box, Stack, Switch, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { MeetingDefinition } from "src/types";

import WebinarPromotionSettings from "./WebinarPromotionSettings";
import {
  EmailTemplatesAccordion,
  ReminderOptions,
  ReminderEmail,
} from "./TemplateEditInviteAndEmail";

interface WebinarEditPromoteProps {
  templateId?: string | number;
}

function WebinarEditPromote({ templateId }: WebinarEditPromoteProps) {
  const { getValues, setValue, clearErrors } =
    useFormContext<MeetingDefinition>();

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold">
        Email
      </Typography>
      <Typography sx={{ mb: 3 }}>
        Because you have selected{" "}
        <Typography fontWeight="bold" component="span">
          Kronologic Event
        </Typography>{" "}
        this will be sent to the customer first, the calendar invite will be
        sent once they have accepted
      </Typography>

      <EmailTemplatesAccordion allowCustomSendTime />

      {/* New section: webinar promotion sender/routing settings */}
      <Box sx={{ mt: 4 }}>
        <WebinarPromotionSettings templateId={templateId} />
      </Box>

      {/* Event Reminder Section */}
      <Box sx={{ mt: 4, mb: 5 }}>
        <Stack sx={{ flexDirection: "row", alignItems: "center" }}>
          <Switch
            checked={getValues("properties.meetingReminder.enabled")}
            onChange={(event) => {
              clearErrors("properties.meetingReminder");

              // do NOT null out the meeting reminder, we can keep what the user has saved
              if (!event.target.checked) {
                return setValue("properties.meetingReminder", {
                  ...getValues("properties.meetingReminder"),
                  enabled: false,
                });
              }

              setValue("properties.meetingReminder", {
                ...getValues("properties.meetingReminder"),
                enabled: true,
              });
            }}
          />
          <Typography variant="h5" fontWeight="bold">
            Event Reminder
          </Typography>
        </Stack>
        <Typography sx={{ mb: 2 }}>
          If enabled, the guest will receive a reminder email at the configured
          interval before the start of the event
        </Typography>

        {getValues("properties.meetingReminder.enabled") && (
          <>
            <ReminderOptions>
              Reminders are scheduled at event creation and sent only to
              accepted guests; not available for same-day events.
            </ReminderOptions>
            <ReminderEmail />
          </>
        )}
      </Box>
    </Box>
  );
}

export default WebinarEditPromote;
